/** @format */

import React, { useContext, useState, useEffect } from "react";
import TituloEditarperfil from "./Titulo-editarperfil";
import Perfil from "../assets/img/perfil.svg";

/* Begin By Javi */
import { Loader } from "../util/loader";
import { apiPerfil } from "../api";
import utils from "./../util";
import { getAlert } from "../util/alert";
import Constantes from "../util/Constantes";
/* End By Javi */

const { isMobile } = utils;
export const EditarPerfil = () => {
  const [dataApoderado, setdataApoderado] = useState({});
  const [stateForm, setStateFrom] = useState(false);
  const [dataForm, setDataForm] = useState({});
  const [dataDepa, setDataDepa] = useState({});
  const [dataProv, setDataProv] = useState({});
  const [dataDist, setDataDist] = useState({});
  const [departamentoCapturado, setDepartamentoCapturado] = useState({});
  const [provinciaCapturado, setProvinciaCapturado] = useState({});
  const [distritoCapturado, setDistritoCapturado] = useState({});
  const dataUser = JSON.parse(localStorage.getItem("userLogin"));
  /* BEGIN BY JAVI */
  const [_isMobile] = useState(isMobile());
  const [Loading, setloading] = useState(false);
  const [alertMessage, setMessage] = useState("Notificación de Perfil");
  const dataDep = {};
  const dataProp = { idDepartamento: 0 };
  const dataDis = { idDepartamento: 0, idProvincia: 0 };
  const [DepLabel, setDepLabel] = useState(null);
  const [ProvLabel, setProvLabel] = useState(null);
  const [DistLabel, setDistLabel] = useState(null);

  /* END BY JAVI */

  const handleInputChange = (event) => {
    setDataForm({ ...dataForm, [event.target.name]: event.target.value });
  };
  const ChangeDataApodetadoHandler = async () => {    
    /* BEGIN BY JAVI */
    if (departamentoCapturado.value == "00") {
      getAlert(Constantes().SeccionDepartamento, "", alertMessage);
    } else if (provinciaCapturado.value == "00") {
      getAlert(Constantes().SeccionProvincia, "", alertMessage);
    } else if (distritoCapturado.value == "00") {
      getAlert(Constantes().SeccionDistrito, "", alertMessage);
    } else {
      setStateFrom(false);
      sendAll();
    }
    /* END BY JAVI */
  };
  /* BEGIN BY JAVI */
  const sendAll = () => {
    setloading(true);
    let ObjSend = {
      id: dataUser.detail.apoderado_id,
      dni: dataUser.detail.dni,
      email: dataForm.email,
      tfijo: dataForm.telefonofijo,
      tcelular: dataForm.telefonocelular,
      direccion: dataForm.direccion,
      ubigeo:
        departamentoCapturado.value +
        provinciaCapturado.value +
        distritoCapturado.value,
    };
    const promise = apiPerfil.Save(ObjSend, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        ActualizaStorageAlumno(dataForm);
      }
    });
  };

  const ActualizaStorageAlumno = (dataForm) => {
    const user = {
      username: dataForm.login,
      password: decodeURIComponent(escape(window.atob(dataForm.password))),
    };
    const promise = apiPerfil.listarAttorney(user, alertMessage);
    promise.then((res) => {
      if (res != undefined) {
        localStorage.setItem("userLogin", JSON.stringify(res));
        window.location.href = "./editar-perfil";
      }
    });
  };

  const handleDepartamentos = (IdProv) => {
    setloading(true);
    const promise = apiPerfil.listarUbigeo(dataDep, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        let dpa = res.departamento.map((_) => {
          return {
            value: _.codDepertamento,
            label: _.nombre,
          };
        });
        setDataDepa({ ...dataDepa, departamentos: dpa });
        /* BEGIN INICIALIZA DEPARTAMENTO */
        let IdDepa = dataUser.detail.ubigeo.substr(0, 2);
        let iniDepa = dpa.filter((_) => _.value == IdDepa);
        setDepLabel(iniDepa[0].label);
        setDepartamentoCapturado(iniDepa);
        /* END INICIALIZA DEPARTAMENTO */
        handleProvincias(IdDepa, IdProv);
      }
    });
  };

  const handleProvincias = (id) => {
    setloading(true);
    dataProp.idDepartamento = id;
    const promise = apiPerfil.listarUbigeo(dataProp, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        let prov = res.provincias.map((_) => {
          return {
            value: _.codProvincia,
            label: _.nombre,
          };
        });
        setDataProv({ ...dataProv, provincias: prov });
        /* BEGIN INICIALIZA PROVINCIA */
        let IdDepa = dataUser.detail.ubigeo.substr(0, 2);
        let IdProv = dataUser.detail.ubigeo.substr(2, 2);
        if (id == IdDepa) {
          let iniProv = prov.filter((_) => _.value == IdProv);
          if (iniProv.length > 0) {
            setProvinciaCapturado(iniProv);
            setProvLabel(iniProv[0].label);
          }
        }
        handleDistritos(id, IdProv);
        /* END INICIALIZA PROVINCIA */
      }
    });
  };

  const handleDistritos = (idDepart, idProvinc) => {
    dataDis.idDepartamento = idDepart;
    dataDis.idProvincia = idProvinc;
    setloading(true);
    const promise = apiPerfil.listarUbigeo(dataDis, alertMessage);
    promise.then((res) => {
      setloading(false);
      if (res != undefined) {
        let dist = res.distrito.map((_) => {
          return {
            value: _.coddist,
            label: _.nombre,
          };
        });
        setDataDist({ ...dataDist, distrito: dist });
        /* BEGIN INICIALIZA DISTRITO */
        let IdDepa = dataUser.detail.ubigeo.substr(0, 2);
        let IdProv = dataUser.detail.ubigeo.substr(2, 2);
        if (idDepart == IdDepa && idProvinc == IdProv) {
          let IdDist = dataUser.detail.ubigeo.substr(4, 2);
          let iniDist = dist.filter((_) => _.value == IdDist);
          if (iniDist.length > 0) {
            setDistritoCapturado(iniDist);
            setDistLabel(iniDist[0].label);
          }
        }
        /* END INICIALIZA DISTRITO */
      }
    });
  };

  const handleDepartamentoschange = (e) => {
    const selected = dataDepa.departamentos.find(dep => dep.value === e.target.value);
    if (!selected) return;

    setDepartamentoCapturado(selected);
    setProvinciaCapturado({ value: "00", label: "Seleccionar Provincia" });
    setDistritoCapturado({ value: "00", label: "Seleccionar Distrito" });

    handleProvincias(selected.value);
  };

  const handleProvinciaschange = (e) => {
    const selected = dataProv.provincias.find(prov => prov.value === e.target.value);
    if (!selected) return;

    setProvinciaCapturado(selected);
    setDistritoCapturado({ value: "00", label: "Seleccionar Distrito" });

    handleDistritos(departamentoCapturado.value, selected.value);
  };

  const handleDistritoschange = (e) => {
    const selected = dataDist.distrito.find(dist => dist.value === e.target.value);
    console.log("selected", selected);
    
    if (!selected) return;

    setDistritoCapturado(selected);
  };

  useEffect(
    () => {
      const dataUser = localStorage.getItem("userLogin");
      setdataApoderado(JSON.parse(dataUser).detail);
      setDataForm(JSON.parse(dataUser).detail);
      /* BEGIN BY JAVI */
      let IdDepa = JSON.parse(dataUser).detail.ubigeo.substr(0, 2);
      let IdProv = JSON.parse(dataUser).detail.ubigeo.substr(2, 2);
      let IdDist = JSON.parse(dataUser).detail.ubigeo.substr(4, 2);
      handleDepartamentos(IdProv);
      /* END BY JAVI */
    },
    [setdataApoderado],
    [setDataDist],
    [setDataProv],
    [setDataDepa]
  );

  return (
    <div>
      {Loader(Loading)}
      <div className="contend">
        <div className="text col-12">
          <div>
            <TituloEditarperfil
              nombreTitulo={"Mi Perfil"}
              isMobile={_isMobile}
              _redirec={"./home"}
              _filter={"D"}
            />
          </div>
          <div className="divisor col-12"></div>
          <div className=" mt-3">
            <div className="row mb-3">
              <div
                className="col-10"
                style={{ fontWeight: "bold", textAlign: "left" }}
              >
                Datos Generales
              </div>
              {_isMobile ? (
                <div className="mt-3 col-12 form-group">
                  <img
                    className=" p-1 background-perfil img-editar-perfil"
                    src={Perfil}
                  ></img>
                </div>
              ) : (
                ""
              )}
            </div>
            {_isMobile ? (
              <div className="col-11 editar-container mt-4">
                <div className="ml-3">
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">DNI:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.dni}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">
                      APELLIDO PATERNO:
                    </label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.apaterno}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">
                      APELLIDO MATERNO:
                    </label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.amaterno}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">NOMBRE:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.nombres}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">EMAIL:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.email}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">TELEFONO FIJO:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.telefonofijo}
                    </label>
                  </div>
                </div>
                <div className="ml-3">
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">CELULAR:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.telefonocelular}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">DIRECCIÓN:</label>
                    <label className="label-control col-12 mb-3">
                      {dataApoderado.direccion}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">DEPARTAMENTO:</label>
                    <label className="label-control col-12 mb-3">
                      {DepLabel != null ? DepLabel : ""}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">CIUDAD:</label>
                    <label className="label-control col-12 mb-3">
                      {ProvLabel != null ? ProvLabel : ""}
                    </label>
                  </div>
                  <div className="mb-3 form-group">
                    <label className="font-weight-bold">DISTRITO:</label>
                    <label className="label-control col-12 mb-3">
                      {DistLabel != null ? DistLabel : ""}
                    </label>
                  </div>
                </div>
              </div>
            ) : (
              <div className="  text-datos-generales">
                <div
                  className=" img-editar-perfil mb-5"
                  style={{ width: "9rem" }}
                >
                  <img
                    className=" p-1 background-perfil img-editar-perfil"
                    src={Perfil}
                  ></img>
                </div>
                <div className="contend-editar-perfil">
                  <div className="list-detalle-apoderado">
                    <label htmlFor="Name" class="font-weight-bold">
                      DNI:
                    </label>
                    <label>{dataApoderado.dni}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      APELLIDO PATERNO:
                    </label>
                    <label>{dataApoderado.apaterno}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      APELLIDO MATERNO:
                    </label>
                    <label>{dataApoderado.amaterno}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      NOMBRE:
                    </label>
                    <label>{dataApoderado.nombres}</label>
                  </div>
                  <div className="list-detalle-apoderado">
                    <label htmlFor="Name" class="font-weight-bold">
                      EMAIL:
                    </label>
                    <label>{dataApoderado.email}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      TELEFONO FIJO:
                    </label>
                    <label>{dataApoderado.telefonofijo}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      CELULAR:
                    </label>
                    <label>{dataApoderado.telefonocelular}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      DIRECCIÓN:
                    </label>
                    <label>{dataApoderado.direccion}</label>
                  </div>
                  <div className="list-detalle-apoderado">
                    <label htmlFor="Name" class="font-weight-bold">
                      DEPARTAMENTO:
                    </label>
                    <label>{DepLabel != null ? DepLabel : ""}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      CIUDAD:
                    </label>
                    <label>{ProvLabel != null ? ProvLabel : ""}</label>
                    <label htmlFor="Name" class="font-weight-bold">
                      DISTRITO:
                    </label>
                    <label>{DistLabel != null ? DistLabel : ""}</label>
                    <label htmlFor="Name"></label>
                    <label></label>
                    <div className="mt-2"></div>
                  </div>
                </div>
              </div>
            )}

            {!stateForm ? (
              <div className="col-12 d-flex justify-content-center mr-5  boton-editar-perfil">
                <button
                  type="button"
                  className="btn btn-warning "
                  onClick={() => {
                    setStateFrom(true);
                  }}
                >
                  Editar
                </button>
              </div>
            ) : null}
          </div>
          <div className=" divisor mt-2 mb-3"></div>
          {stateForm ? (
            <form>
              <div className="col-11 editar-container mt-4">
                <div className="ml-3">
                  <div className="mb-3 form-group">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">EMAIL:</p>
                    </label>
                    <input
                      type="text"
                      className="form-control col-12"
                      placeholder="Email"
                      value={dataForm.email}
                      name="email"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">TELEFONO FIJO:</p>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Telefono Fijo"
                      value={dataForm.telefonofijo}
                      name="telefonofijo"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-groupmb-3">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">CELULAR:</p>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Celular"
                      value={dataForm.telefonocelular}
                      name="telefonocelular"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="form-group mb-3 mt-3">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">DIRECCION:</p>
                    </label>
                    <input
                      type="text"
                      className="form-control col-12"
                      placeholder="Dirección"
                      value={dataForm.direccion}
                      name="direccion"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className=" drop-editar-perfil">
                  <div className="form-group content-form-select">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">DEPARTAMENTO:</p>
                    </label>
                    <select
                      className="form-select"
                      value={departamentoCapturado?.value || "00"}
                      onChange={handleDepartamentoschange}
                    >
                      <option value="00" disabled>Seleccionar Departamento</option>
                      {dataDepa.departamentos?.map(dep => (
                        <option key={dep.value} value={dep.value}>{dep.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group content-form-select mt-3">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">CIUDAD:</p>
                    </label>
                    <select
                      className="form-select mt-3"
                      value={provinciaCapturado?.value || "00"}
                      onChange={handleProvinciaschange}
                    >
                      <option value="00" disabled>Seleccionar Provincia</option>
                      {dataProv.provincias?.map(prov => (
                        <option key={prov.value} value={prov.value}>{prov.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group content-form-select mt-3 mb-3">
                    <label htmlFor="formGroupExampleInput">
                      <p className="font-weight-bold">DISTRITO:</p>
                    </label>
                    <select
                      className="form-select mt-3 mb-3"
                      value={distritoCapturado?.value || "00"}
                      onChange={handleDistritoschange}
                    >
                      <option value="00" disabled>Seleccionar Distrito</option>
                      {dataDist.distrito?.map(dist => (
                        <option key={dist.value} value={dist.value}>{dist.label}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-6" style={{ textAlign: "right" }}>
                  <button
                    type="button"
                    className="btn btn-danger "
                    onClick={() => {
                      setStateFrom(false);
                    }}
                  >
                    Cancelar
                  </button>
                </div>
                <div className="col-6" style={{ textAlign: "left" }}>
                  <button
                    type="button"
                    className="btn btn-warning "
                    onClick={ChangeDataApodetadoHandler}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </form>
          ) : null}
        </div>
      </div>
    </div>
  );
};
